export const SELECTED_EMPRESA_CHANGED = 'SELECTED_EMPRESA_CHANGED'

export function selectedEmpresaChanged(empresaId) {
  return {
    type: SELECTED_EMPRESA_CHANGED,
    payload: { empresaId },
  }
}
